import type { PeriodPreset } from "../sales-explorer/period-presets";

export const PAGE_SIZE = 20;

export type MapaMode = "all" | "with" | "without";

export interface PrescriptionsReportFilters {
  from: string;
  to: string;
  period: PeriodPreset;
  search: string;
  sequence: string;
  vetId: string;
  mapaMode: MapaMode;
  page: number;
}

export interface PrescriptionReportRow {
  id: string;
  medicalRecordId: string | null;
  issuedAt: string | null;
  sequence: number | null;
  identifier: string | null;
  petId: string | null;
  petName: string | null;
  ownerId: string | null;
  ownerName: string | null;
  vetName: string | null;
  signed: boolean;
}

export interface PrescriptionsReportResult {
  rows: PrescriptionReportRow[];
  totalCount: number;
}
